import { withInstall } from '@lit-element/utils'
import Alert from './src/alert.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtAlert: SFCWithInstall<typeof Alert> = withInstall(Alert)
export default LtAlert

export * from './src/alert'
export type { AlertInstance } from './src/instance'
